import data from './data'

export default {
    data
}